import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, MapPin, Flame } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-20 overflow-hidden" data-id="element-202">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-203">
        <img src="https://cdn.magicpatterns.com/uploads/xvRyVgKi5YPPVChS49kEjL/hero.png" alt="Gimnasio San Miguel Entrenamiento" className="w-full h-full object-cover object-[50%_30%] md:object-center" data-id="element-204" />
        <div className="absolute inset-0 bg-gradient-to-b from-gym-dark/80 via-gym-dark/70 to-gym-dark" data-id="element-205"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center" data-id="element-206">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} data-id="element-207">
          <div className="inline-flex items-center gap-2 bg-gym-charcoalLight/80 border border-gym-gold/30 px-4 py-2 rounded-full mb-8 backdrop-blur-sm" data-id="element-208">
            <MapPin size={16} className="text-gym-gold" data-id="element-209" />
            <span className="text-sm font-medium tracking-wide text-gray-200 uppercase" data-id="element-210">
              San Miguel, Lima
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight uppercase tracking-tight" data-id="element-211">
            ¿Por qué sigues yendo al gimnasio{' '}
            <span className="text-gym-green" data-id="element-212">sin ver resultados?</span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 font-medium mb-10 italic" data-id="element-213">
            (La respuesta te va a incomodar — pero también te va a liberar)
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-214">
            <a href="https://wa.me/51915013918" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-3 bg-gym-green hover:bg-gym-greenHover text-white px-8 py-4 rounded-full font-bold text-lg transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(16,185,129,0.4)]" data-id="element-215">
              <MessageCircle size={24} data-id="element-216" />
              QUIERO MI CLASE GRATIS
            </a>
          </div>

          {/* Counter Bar */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 1.2
        }} className="mt-8" data-id="element-217">
            <div className="inline-flex items-center gap-2 bg-gym-charcoalLight/70 backdrop-blur-sm border border-gym-green/20 px-5 py-2.5 rounded-full" data-id="element-218">
              <Flame size={16} className="text-orange-500 animate-pulse" data-id="element-219" />
              <span className="text-sm text-gray-200 font-medium" data-id="element-220">
                <span className="text-gym-green font-bold" data-id="element-221">47 personas</span>{' '}
                reservaron esta semana en San Miguel
              </span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}